// extracted by mini-css-extract-plugin
module.exports = {"related-blogs":"related-blogs_related-blogs__3hjci"};